{
  "REGISTER": {
    "TRY_WOOT": "Fiók létrehozása",
    "TITLE": "Regisztrálás",
    "TESTIMONIAL_HEADER": "Már csak egy lépés van hátra",
    "TESTIMONIAL_CONTENT": "Már csak egy lépésre vagy!",
    "TERMS_ACCEPT": "A fiók létrehozásával elfogadod az <a href=\"https://chat.jarabot.com/terms\">ÁSZF</a> és az <a href=\"https://chat.jarabot.com/privacy-policy\">Adatkezelési nyilatkozat</a> tartalmát",
    "TERMS_LINKS": "<a href=\"https://chat.jarabot.com/terms\">Általános Szerződési Feltételek</a> - <a href=\"https://chat.jarabot.com/privacy-policy\">Adatvédelmi szabályzat</a>",
    "OAUTH": {
      "GOOGLE_SIGNUP": "Regisztráció Google-el"
    },
    "COMPANY_NAME": {
      "LABEL": "Cég neve",
      "PLACEHOLDER": "Enter your company name. eg: Wayne Enterprises",
      "ERROR": "Company name is too short"
    },
    "FULL_NAME": {
      "LABEL": "Teljes név",
      "PLACEHOLDER": "Add meg a teljes neved. Pl.: Kovács János",
      "ERROR": "A teljes név túl rövid"
    },
    "EMAIL": {
      "LABEL": "Munkahelyi e-mail",
      "PLACEHOLDER": "Adja meg a munkahelyi e-mail-címét. Pl.: bruce{'@'}wayne{'.'}enterprises",
      "ERROR": "Please enter a valid work email address"
    },
    "PASSWORD": {
      "LABEL": "Jelszó",
      "PLACEHOLDER": "Jelszó",
      "ERROR": "A jelszó túl rövid",
      "IS_INVALID_PASSWORD": "Password should contain atleast 1 uppercase letter, 1 lowercase letter, 1 number and 1 special character"
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Jelszó megerősítése",
      "PLACEHOLDER": "Jelszó megerősítése",
      "ERROR": "A jelszavak nem egyeznek"
    },
    "API": {
      "SUCCESS_MESSAGE": "Sikeres regisztráció",
      "ERROR_MESSAGE": "Nem sikerült csatlakozni a Woot szerverhez, kérjük próbáld később"
    },
    "SUBMIT": "Fiók létrehozása",
    "HAVE_AN_ACCOUNT": "Már van fiókod?"
  }
}
